"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var use_is_mounted_1 = __importDefault(require("./use-is-mounted"));
exports.default = use_is_mounted_1.default;
